import { Box, Typography, Paper } from '@mui/material';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';
import { NotificationSearchField } from './NotificationSearchField';
import { NotificationSearchResults } from './NotificationSearchResults';
import { NotificationSearchEmptyState } from './NotificationSearchEmptyState';
import { NotificationSearchNoResultsState } from './NotificationSearchNoResultsState';

interface NotificationSectionProps {
  teamAbbrv: string;
  searchQuery: string;
  isSearching: boolean;
  searchResults: VideoItem[];
  onSearchQueryChange: (query: string) => void;
  onMoreInfo: (video: VideoItem) => void;
  onCreateDeeplink: (video: VideoItem) => void;
}

export function NotificationSection({
  teamAbbrv,
  searchQuery,
  isSearching,
  searchResults,
  onSearchQueryChange,
  onMoreInfo,
  onCreateDeeplink,
}: NotificationSectionProps) {
  const hasQuery = searchQuery.trim().length > 0;
  const hasResults = searchResults.length > 0;

  return (
    <Paper variant="outlined" sx={{ mt: 3, mx: 3, p: 0 }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
          Notiser och djuplänkar
        </Typography>
        <NotificationSearchField
          value={searchQuery}
          isSearching={isSearching}
          onChange={onSearchQueryChange}
        />
        {hasResults ? (
          <NotificationSearchResults
            teamAbbrv={teamAbbrv}
            results={searchResults}
            onMoreInfo={onMoreInfo}
            onCreateDeeplink={onCreateDeeplink}
          />
        ) : !hasQuery ? (
          <NotificationSearchEmptyState />
        ) : (
          <NotificationSearchNoResultsState />
        )}
      </Box>
    </Paper>
  );
}
